<template>
    <div class="tl video-tree">

        <template >


            <el-tabs  @tab-click="handleClick" >

                <el-tab-pane label="统计信息" class="tabWidth">
                <div v-if="tabIndex == 0">
                    <import-leader ></import-leader>
                </div>
            </el-tab-pane>

                <el-tab-pane label="导入记录" class="tabWidth">
                    <div v-if="tabIndex == 1">
                        <stats-info></stats-info>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </template>
    </div>
</template>

<script>


    import ImportLeader from "./importLeader/ImportLeader";
    import StatsInfo from "./statsinfo/StatsInfo";
    // import PunchImport from "./punchImport/PunchImport";


    export default {
        name: "TabsList",
        components: {
            ImportLeader,
            StatsInfo,
            // PunchImport
        },
        props:{
            tabslist:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                formvalue:{},
                tabIndex:0,
                i_type:-1,
                // i_show:1,
            }
        },
        // watch:{
        //     tabslist(){
        //         if (this.tabslist){
        //             this.i_type=this.tabslist.i_id;
        //             this.i_show=this.tabslist.i_show;
        //             this.formvalue=this.tabslist;
        //             // console.log(this.tabslist,"this.formvalue111");
        //
        //         }
        //     },
        //     immediate:true,
        //     deep:true
        // },
        mounted() {

        },
        methods: {
            handleClick(tab){
                this.tabIndex = tab.index;
                // console.log(tab.index)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .el-tabs{
        height:100% !important;

    }

    //实现滚动功能
    .video-tree {
        overflow-y: auto;
        /*padding-left: 20px;*/
    }
    /deep/{
        .el-tabs__header{
            margin: 0 !important;
        }
        .el-tabs__nav-wrap::after{
            background-color: white;
        }
        .el-tabs__item.is-active{
            font-weight: bold;
            color: black;
            /*border-bottom:1px solid orange ;*/
        }
        .el-tabs__active-bar{
            background-color: orange;
        }
        .el-tabs__nav-scroll{
            display: flex;
            align-items: center;
            height: 40px;
            background-color: rgb(255,255,255);
            /*padding:10px 20px !important;*/
            padding-left: 30px;
            /*background-color: rgb(241,241,241);*/
        }
        .el-tabs__nav-wrap{
            overflow: visible;
        }
    }
    /deep/{
        .el-tabs__item{
            height: 32px;
            line-height: 32px;
        }
        .el-tabs__nav-next, .el-tabs__nav-prev{
            line-height: 32px;
        }
    }

</style>